/**
 * Per-unit for the payload; server does `Math.round(perUnit * qty)`, so the
 * exact `deduction / qty` float round-trips to the cap. Flooring would drop up
 * to (qty − 1) øre.
 */
export function toPerUnitDeduction(
  deduction: number,
  quantity: number
): number {
  if (quantity <= 0) {
    return 0;
  }
  return deduction / quantity;
}
